import React, {useState} from "react"
import {FieldTableCellProps} from "../../../../../render/table/table-cell"
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../../../gd-components/buttons/control-button/control-button-standard"
import {currencySymbol} from "../../../../../../gd/format/currency-symbol"
import {isBulkSelection} from "../../../../../../gd/right-click-menu"
import {ItemModelV2_CalculatedValues} from "../../../../../../model2/item2/calculated/@type"

// const debug = "FieldItemModelCalculatedExpenses_TableCell"
const debug = false

export default function FieldItemModelCalculatedExpenses_TableCell(props:FieldTableCellProps) {

    let isEditable  : boolean   = !props.manager.isReadOnly && props.listItem.item.acl.canAddExpense

    // STATE & hovered
    const [isHovered, setIsHovered] = useState(false)

    const onMouseEnter = () => {
        if (!isEditable) {
            return
        }

        if (!isHovered) {
            setIsHovered(true)
        }
    }

    const onMouseLeave = () => {
        if (isHovered) {
            setIsHovered(false)
        }
    }

    const addExpense = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) {
            return
        }

        if (props.listItem.isTask) {
            gd.modules.expenses.newTaskExpense(props.listItem.task)
        }

        if (props.listItem.isProject) {
            gd.modules.expenses.newProjectExpense(props.listItem.project.id)
        }
    }

    const getStyle = () => {

        // this is common part for table cell
        // end common part

        const width = props.column.width

        const style : style = _.clone(props.style) || {} // we need clone here because we add width!
        style.width = width

        return style
    }

    const renderHovered = () => {

        /*const classes       = Classes("cell-flex is-hovered")
        const showChildren  = props.listItem.view.isCollapsed && props.listItem.calculated.calculatedExpenses.children>0*/

        const calculatedValues: ItemModelV2_CalculatedValues | undefined = props.listItem.calculated.dataByAggregateFunction[props.field.fieldId as keyof {}]?.[props.column.aggregateFunction!]
        const ownValue = calculatedValues?.own || props.field.getViewValue(props.listItem.item)

        const showSummaryView   = /*props.listItem.isGroup ||*/ props.listItem.view.isCollapsed
        const showChildren      = showSummaryView && !!calculatedValues?.children.value && calculatedValues?.children.value > 0
        const showOwnValue      = ownValue > 0
        const showPlus          = showOwnValue && showChildren

        return (
            <div className="cell-flex is-hovered" style={getStyle()} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                <div className="ui5-field-editable size-small is-hovered w-100-percent h-100-percent"
                     onClick={addExpense}>
                    <div className="flex-row-left-center truncate">

                        {showOwnValue &&
                            <>
                                <span className="ui5-txt-not-important-small m-r-3">{currencySymbol()}</span>
                                <div
                                    className="ui5-txt-less-important-small">{props.field.getDisplayValue(ownValue)}</div>
                            </>}

                        {showPlus &&
                            <div className="ui5-txt-less-important-small m-r-5 m-l-5">+</div>}

                        {showChildren &&
                            <>
                                <div className="ui5-ico-12 i5-folder-tree m-r-5 m-t-1"/>
                                <span className="ui5-txt-not-important-small m-r-3">{currencySymbol()}</span>
                                <div className="ui5-txt-less-important-small">
                                    {props.field.getDisplayValue(calculatedValues?.children.value)}
                                </div>
                            </>}
                    </div>
                    <div className="buttons">
                        <ControlButtonStandard
                            className   = "btn-add"
                            type        = {ControlButtonType.PLUS}
                            size        = {24}
                            hint        = "Add Expense"
                            onClick     = {addExpense}
                        />
                    </div>
                </div>
            </div>
        )
    }

    const renderNotHovered = () => {
        const classes = Classes("cell-flex ui5-txt-less-important-small ui5-field-editable size-small", {})

        /*let notHoveredContent = null
        let showSummary = false

        if (props.listItem.view.isCollapsed &&
            props.listItem.calculated.calculatedExpenses.total &&
            props.listItem.calculated.calculatedExpenses.total != props.listItem.calculated.calculatedExpenses.own) {
            notHoveredContent = props.field.getDisplayValue(props.listItem.calculated.calculatedExpenses.total)
            showSummary = props.column.isAggregatedBySum
        } else if (props.listItem.calculated.calculatedExpenses.own) {
            notHoveredContent = props.field.getDisplayValue(props.listItem.calculated.calculatedExpenses.own)
        } else {
            // display nothing :)
        }*/

        const showSummaryView   = /*props.listItem.isGroup ||*/ props.listItem.view.isCollapsed
        let notHoveredContent   = null
        let aggregateIcon

        const calculatedValues: ItemModelV2_CalculatedValues | undefined = props.listItem.calculated.dataByAggregateFunction[props.field.fieldId as keyof {}]?.[props.column.aggregateFunction!]
        const ownValue = calculatedValues?.own || props.field.getViewValue(props.listItem.item)

        debug && console.log(debug, "renderNotHovered", showSummaryView, calculatedValues)

        if (showSummaryView && !!calculatedValues?.total.value && calculatedValues.total.value != calculatedValues.own) {
            notHoveredContent = props.field.getDisplayValue(calculatedValues.total.value)
            aggregateIcon = <div className={Classes("ui5-ico-12 m-r-5 m-t-1", props.column.aggregator?.icon)}/>
        } else if (ownValue > 0) {
            notHoveredContent = props.field.getDisplayValue(ownValue)
        }

        return (
            <div className={classes} style={getStyle()} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                {aggregateIcon
                }
                {notHoveredContent &&
                    <span className="ui5-txt-not-important-small m-r-3">{currencySymbol()}</span>}

                {notHoveredContent}
            </div>
        )
    }

    debug && console.log(debug, "render() isHovered=", isHovered)

    if (isHovered) {
        return renderHovered()
    } else {
        return renderNotHovered()
    }
}
